function GlobalMenuHover() {
    let MenuList = document.querySelectorAll('.menu_list_item')
    MenuList.forEach(function(item){
        item.addEventListener('mouseenter', function(){
            item.style.opacity = '0'
        });
        item.addEventListener('mouseleave', function(){
            item.style.opacity = '1'
        });
        
    })
}
GlobalMenuHover();
// GlobalMenuHover()
// console.log(MenuList)